
import React, { useEffect, useState } from 'react'
import Header from '../../common/Header'
import Sidebar from '../../common/Sidebar'
import PageHeader from '../PageHeader'
import Footer from '../../common/Footer'
import axios from 'axios'
import { downloadDataInCsv, get_user_menu_permission, triggerAlert } from '../../utils'
import DataTable from 'react-data-table-component'
import Loader from '../../common/Loader'
import { menuIdData } from '../../utils/constants'
import Cookies from 'js-cookie';
export default function BillingInfo() {
    document.title = "Digital Employees - BillingInfo"
    const mainHeading = "Billing Information";
    const heading = "Billing / Billing Information";
    const [isLoading, setIsLoading] = useState(false);
    const [billingInfo, setBillingInfo] = useState([]);
    const [userBillingInfo, setUserBillingInfo] = useState([]);
    const [userSubscription, setUserSubscription] = useState(null);
    const [userTransactions, setUserTransactions] = useState([]);
    const [userTopups, setUserTopups] = useState([]);
    const [userBalance, setUserBalance] = useState(null);
    const [userPaymentMethod, setUserPaymentMethod] = useState(null);
    const [showUserBillingInfo, setShowUserBillingInfo] = useState(false);
    const [exportPermission, setExportPermission] = useState(false);
    const [count, setCount] = useState(0);
    const [count1, setCount1] = useState(0);
    const [custid, setId] = useState(0);
    const fetchBillingInfo = async () => {
        setIsLoading(true);
        try {
            let token = Cookies.get("admin_user_token");
            const response = await axios.get(`api/admin/get-billing-infoV2/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            const responseData = response.data;

            // Handle plain array, or wrapped in { results: [] } / { data: [] }
            let itemsArray = [];
            if (Array.isArray(responseData)) {
                itemsArray = responseData;
            } else if (responseData && Array.isArray(responseData.results)) {
                itemsArray = responseData.results;
            } else if (responseData && Array.isArray(responseData.data)) {
                itemsArray = responseData.data;
            }

            itemsArray.forEach((item) => {
                item.grand_total = parseFloat(item.recurring_amount) || 0;
            });

            console.log('BillingInfo data:', itemsArray);
            setBillingInfo(itemsArray);
            setCount(itemsArray.length);
            setIsLoading(false);
        } catch (error) {
            console.error('fetchBillingInfo error:', error);
            setIsLoading(false);
            triggerAlert("error", "Oops...", "Something went wrong..");
        }
    }

    const fetchUserBillingInfo = async (id) => {
        setId(id);
        setShowUserBillingInfo(true);
        setIsLoading(true);
        try {
            const token = Cookies.get("admin_user_token");
            const response = await axios.get(`api/admin/customer-bil-detailsV2/?customer_id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            const results = response.data?.results || {};
            setUserSubscription(results.subscription || null);
            setUserBalance(results.balance ?? null);
            setUserPaymentMethod(results.payment_method || null);
            setUserTransactions(Array.isArray(results.recent_transactions) ? results.recent_transactions : []);
            setUserTopups(Array.isArray(results.topups) ? results.topups : []);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            triggerAlert("error", "Oops...", "Something went wrong..");
        }
    }
    // useEffect(() => {
    //     if (count1 > 0 && custid !== undefined) {
    //         fetchUserBillingInfo(custid);
    //     }
    // }, [custid])
    const exportToExcel = () => {
        const customHeaders = {
            user_name: 'Username',
            user_email: 'Email',
            plan_name: 'Plan Name',
            billing_cycle: 'Billing Cycle',
            status: 'Status',
            recurring_amount: 'Amount($)',
            credit_balance: 'Credit Balance',
        };
        downloadDataInCsv(billingInfo, 'billing_info.csv', customHeaders, 'recurring_amount');
    }


    function exportToExcel1(data) {
        // Parse JSON data
        const { data: dataArray, total_amount, plan_tax_amount, grand_total_amount, company_name } = data;

        // Prepare CSV content
        let csvContent = 'Serial Number,Service Name,Service Lines,Service Charge,Total\n';
        dataArray.forEach((item, index) => {
            csvContent += `${index + 1},"${item.service_name}",${item.service_lines},${item.service_charge},$${item.total}\n`;
        });

        // Add rows for total amount, plan tax amount, and grand total amount with dollar symbols
        csvContent += `,,,Total Amount,$${total_amount}\n`;
        csvContent += `,,,Plan Tax Amount,$${plan_tax_amount}\n`;
        csvContent += `,,,Grand Total Amount,$${grand_total_amount}\n`;

        // Convert CSV content to Blob
        const blob = new Blob([csvContent], { type: 'text/csv' });

        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        // Set download filename with company name and billing info
        a.download = `${company_name}_billing_info.csv`;

        // Append anchor to body and trigger download
        document.body.appendChild(a);
        a.click();

        // Clean up
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }

    // const exportToExcel1 = () => {
    //     // const selectedColumns = ['firstName', 'age'];
    //     const customHeaders = {
    //         service_name: 'Service Name',
    //         service_lines: 'Service Lines',
    //         service_charge: 'Service Charge',
    //         total: 'total',
    //         //grand_total_amount: 'Grand Total Bill($)',
    //         // ... add more custom headers as needed
    //     };
    //     downloadDataInCsv(userBillingInfo.data, 'user_balance_info.csv', customHeaders);
    // }

    useEffect(() => {
        fetchBillingInfo();
        const menu_id = menuIdData?.customer_list;
        setExportPermission(get_user_menu_permission(menu_id, 'export'));
    }, [])
    const customStyles = {
        table: {
            style: {
                backgroundColor: "#ffffff",
                borderRadius: "8px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#064c77",
                borderBottom: "1px solid #dee2e6",
                minHeight: "52px",
            },
        },
        headCells: {
            style: {
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "56px",
                backgroundColor: "#ffffff",
                "&:hover": {
                    backgroundColor: "#f8f9fa",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                },
            },
        },
        cells: {
            style: {
                fontSize: "14px",
                color: "#495057",
                borderBottom: "1px solid #f1f3f5",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #dee2e6",
                padding: "8px",
            },
        },
        noData: {
            style: {
                backgroundColor: "#ffffff",
                color: "#6c757d",
                padding: "24px",
            },
        },
    };

    const columns = [
        {
            name: 'S.no',
            selector: (row, index) => index + 1,
            width: '70px'
        },
        {
            name: 'Username',
            selector: row => row.user_name || '-',
            cell: row => (
                <span
                    style={{ cursor: 'pointer', color: '#0066cc' }}
                    onClick={() => { fetchUserBillingInfo(row.user); setId(row.user); }}
                >
                    {row.user_name || '-'}
                </span>
            )
        },
        {
            name: 'Email',
            selector: row => row.user_email || '-'
        },
        {
            name: 'Plan',
            selector: row => row.plan_name || '-'
        },
        {
            name: 'Billing Cycle',
            selector: row => row.billing_cycle ? row.billing_cycle.charAt(0).toUpperCase() + row.billing_cycle.slice(1) : '-'
        },
        {
            name: 'Status',
            selector: row => row.status || '-',
            cell: row => (
                <span style={{
                    padding: '3px 10px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '600',
                    backgroundColor: row.status === 'active' ? '#d4edda' : '#f8d7da',
                    color: row.status === 'active' ? '#155724' : '#721c24'
                }}>
                    {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '-'}
                </span>
            )
        },
        {
            name: 'Credit Balance',
            selector: row => row.credit_balance !== undefined ? row.credit_balance : '-'
        },
        {
            name: 'Amount ($)',
            selector: row => `$ ${parseFloat(row.recurring_amount || 0).toFixed(2)}`
        }
    ]

    return (
        <>
            <div id="layout-wrapper">

                <Header />
                <Sidebar />

                {/* <!-- ============================================================== -->
                <!-- Start right Content here -->
                <!-- ============================================================== --> */}
                <div className="main-content">
                    <div className="page-content" style={{ backgroundColor: "#ededed" }}>
                        <div className="container-fluid" >
                            <PageHeader mainHeading={mainHeading} heading={heading} />

                            <div className="row ">
                                <div className="col-12">
                                    <div className="">
                                        <div className="">
                                            {!showUserBillingInfo &&
                                                <>
                                                    <div className="py-2 d-flex justify-content-end">
                                                        {exportPermission &&
                                                            <button className="btn btn-success  px-3" type="button" onClick={exportToExcel}>
                                                                <i className="mdi mdi-file-export-outline" style={{ fontSize: 'large' }}></i> Export to Excel
                                                            </button>
                                                        }
                                                    </div>
                                                    <div className='table-overflow'>
                                                        <DataTable
                                                            columns={columns}
                                                            data={billingInfo}
                                                            progressPending={isLoading}
                                                            progressComponent={<Loader />}
                                                            noDataComponent={<div className="text-center p-4">No data available</div>}
                                                            striped
                                                            highlightOnHover
                                                            pointerOnHover
                                                            customStyles={customStyles}
                                                        />
                                                        <div className="row mt-3">
                                                            <div className="col-md-10 text-end pe-3 py-3">
                                                                <p className="mb-2 px-2">Grand Total</p>
                                                            </div>
                                                            <div className="col-md-2 py-3">
                                                                <p className='fw-semibold mb-2'>$ {billingInfo.map(item => parseFloat(item.recurring_amount) || 0).reduce((prev, next) => prev + next, 0).toFixed(2)}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {showUserBillingInfo &&
                                                <>
                                                    {/* Header */}
                                                    <div className="py-2 d-flex justify-content-between align-items-center mb-3">
                                                        <h4 className="mb-0">
                                                            {userSubscription?.user_name || '-'}
                                                            <small className="text-muted ms-2" style={{ fontSize: '14px' }}>{userSubscription?.user_email || ''}</small>
                                                        </h4>
                                                        <button className="btn btn-warning px-5" type="button" onClick={() => setShowUserBillingInfo(false)}>
                                                            Back
                                                        </button>
                                                    </div>

                                                    {/* Summary Cards */}
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <div className="card border-0 shadow-sm p-3" style={{ borderLeft: '4px solid #064c77', borderRadius: '8px' }}>
                                                                <p className="text-muted mb-1" style={{ fontSize: '12px', textTransform: 'uppercase', fontWeight: 600 }}>Credit Balance</p>
                                                                <h5 className="mb-0 fw-bold" style={{ color: '#064c77' }}>{userBalance ?? '-'} credits</h5>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="card border-0 shadow-sm p-3" style={{ borderLeft: '4px solid #28a745', borderRadius: '8px' }}>
                                                                <p className="text-muted mb-1" style={{ fontSize: '12px', textTransform: 'uppercase', fontWeight: 600 }}>Payment Method</p>
                                                                <h6 className="mb-0 fw-bold">
                                                                    {userPaymentMethod ? `${userPaymentMethod.card_brand} •••• ${userPaymentMethod.card_last4}` : 'N/A'}
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="card border-0 shadow-sm p-3" style={{ borderLeft: '4px solid #ffc107', borderRadius: '8px' }}>
                                                                <p className="text-muted mb-1" style={{ fontSize: '12px', textTransform: 'uppercase', fontWeight: 600 }}>Plan</p>
                                                                <h6 className="mb-0 fw-bold">
                                                                    {userSubscription?.plan_name || '-'}&nbsp;
                                                                    <span style={{ fontSize: '12px', color: userSubscription?.status === 'active' ? '#155724' : '#721c24' }}>
                                                                        ({userSubscription?.status || '-'})
                                                                    </span>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Subscription Info Table */}
                                                    <h6 className="fw-bold mb-2" style={{ color: '#064c77' }}>Subscription Details</h6>
                                                    <DataTable
                                                        columns={[
                                                            { name: 'Plan Name', selector: row => row.plan_name || '-' },
                                                            { name: 'Billing Cycle', selector: row => row.billing_cycle ? row.billing_cycle.charAt(0).toUpperCase() + row.billing_cycle.slice(1) : '-' },
                                                            {
                                                                name: 'Status',
                                                                selector: row => row.status || '-',
                                                                cell: row => (
                                                                    <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', backgroundColor: row.status === 'active' ? '#d4edda' : '#f8d7da', color: row.status === 'active' ? '#155724' : '#721c24' }}>
                                                                        {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '-'}
                                                                    </span>
                                                                )
                                                            },
                                                            { name: 'Credits/Cycle', selector: row => row.credits_per_cycle ?? '-' },
                                                            { name: 'Credit Balance', selector: row => row.credit_balance ?? '-' },
                                                            { name: 'Period Start', selector: row => row.current_period_start ? new Date(row.current_period_start).toLocaleDateString() : '-' },
                                                            { name: 'Period End', selector: row => row.current_period_end ? new Date(row.current_period_end).toLocaleDateString() : '-' },
                                                            { name: 'Amount ($)', selector: row => `$ ${parseFloat(row.recurring_amount || 0).toFixed(2)}` }
                                                        ]}
                                                        data={userSubscription ? [userSubscription] : []}
                                                        progressPending={isLoading}
                                                        progressComponent={<Loader />}
                                                        noDataComponent={<div className="text-center p-4">No subscription data</div>}
                                                        customStyles={customStyles}
                                                    />

                                                    {/* Recent Transactions Table */}
                                                    <h6 className="fw-bold mt-4 mb-2" style={{ color: '#064c77' }}>Recent Transactions</h6>
                                                    <DataTable
                                                        columns={[
                                                            { name: 'S.no', selector: (row, index) => index + 1, width: '70px' },
                                                            {
                                                                name: 'Type',
                                                                selector: row => row.transaction_type,
                                                                cell: row => {
                                                                    const typeColors = { purchase: { bg: '#d4edda', color: '#155724' }, deduction: { bg: '#f8d7da', color: '#721c24' }, topup: { bg: '#cce5ff', color: '#004085' } };
                                                                    const s = typeColors[row.transaction_type] || { bg: '#e2e3e5', color: '#383d41' };
                                                                    return <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', backgroundColor: s.bg, color: s.color }}>{row.transaction_type ? row.transaction_type.charAt(0).toUpperCase() + row.transaction_type.slice(1) : '--'}</span>;
                                                                }
                                                            },
                                                            { name: 'Amount', selector: row => row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : '-' },
                                                            { name: 'Balance After', selector: row => row.balance_after ? parseFloat(row.balance_after).toFixed(2) : '-' },
                                                            { name: 'Description', selector: row => row.description || '-', wrap: true },
                                                            { name: 'Source', selector: row => row.source || '-' },
                                                            { name: 'Date', selector: row => row.created_at ? new Date(row.created_at).toLocaleString() : '-' }
                                                        ]}
                                                        data={userTransactions}
                                                        progressPending={isLoading}
                                                        progressComponent={<Loader />}
                                                        noDataComponent={<div className="text-center p-4">No transactions found</div>}
                                                        highlightOnHover
                                                        customStyles={customStyles}
                                                    />

                                                    {/* Topups Table */}
                                                    <h6 className="fw-bold mt-4 mb-2" style={{ color: '#064c77' }}>Top-Ups</h6>
                                                    <DataTable
                                                        columns={[
                                                            { name: 'S.no', selector: (row, index) => index + 1, width: '70px' },
                                                            { name: 'Pack', selector: row => row.pack__name || '-' },
                                                            { name: 'Credits', selector: row => row.credits_purchased ?? '-' },
                                                            { name: 'Bonus Credits', selector: row => row.bonus_credits ?? '-' },
                                                            { name: 'Amount ($)', selector: row => row.amount != null ? `$ ${parseFloat(row.amount).toFixed(2)}` : '-' },
                                                            { name: 'Charged ($)', selector: row => row.charged_amount != null ? `$ ${parseFloat(row.charged_amount).toFixed(2)}` : '-' },
                                                            {
                                                                name: 'Status',
                                                                selector: row => row.status || '-',
                                                                cell: row => (
                                                                    <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', backgroundColor: row.status === 'succeeded' ? '#d4edda' : '#f8d7da', color: row.status === 'succeeded' ? '#155724' : '#721c24' }}>
                                                                        {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '-'}
                                                                    </span>
                                                                )
                                                            },
                                                            { name: 'Date', selector: row => row.created_at ? new Date(row.created_at).toLocaleDateString() : '-' }
                                                        ]}
                                                        data={userTopups}
                                                        progressPending={isLoading}
                                                        progressComponent={<Loader />}
                                                        noDataComponent={<div className="text-center p-4">No top-ups found</div>}
                                                        highlightOnHover
                                                        customStyles={customStyles}
                                                    />
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div> {/*end col  */}
                            </div> {/*end row  */}
                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- End Page-content --> */}

                    <Footer />
                </div>
                {/* <!-- end main content--> */}
            </div>
            {/* <!-- END layout-wrapper*/}

            {/* <!-- Right bar overlay--> */}
            <div className="rightbar-overlay"></div>
        </>
    )
}
